export default __webpack_public_path__ + "static/national-metric-desktop-337b0f7e0b3453c698374dea9c876ce4.svg";